import React from 'react';
import {
  Dashboard as DashboardIcon,
  ShoppingCart as VentasIcon,
  Store as ComprasIcon,
  Inventory as InventarioIcon,
  AccountBalance as TesoreriaIcon,
  Category as CategoryIcon,
  SwapHoriz as SwapHorizIcon,
  ListAlt as ListAltIcon,
  QuestionAnswer as ConsultasIcon,
  Assessment as AssessmentIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  MenuBook as MenuBookIcon,
  AccountTree as AccountTreeIcon,
  Schema as SchemaIcon,
  PriceChange as PriceChangeIcon,
  Route as RouteIcon,
  Build as ServicioIcon,
  Engineering as EngineeringIcon,
  DirectionsCar as DirectionsCarIcon,
  EventAvailable as EventAvailableIcon,
  CalendarViewWeek as CalendarViewWeekIcon,
  BuildCircle as BuildCircleIcon,
  PrecisionManufacturing as ProduccionIcon,
  Science as RecetaIcon,
  Factory as OrdenProduccionIcon,
  Checkroom as FashionIcon,
  Palette as PaletteIcon,
  Percent as PercentIcon,
  Straighten as StraightenIcon,
  WbSunny as TemporadaIcon,
  Style as ModeloIcon,
  AssignmentReturn as AssignmentReturnIcon,
  Contacts as ContactsIcon,
  Business as BusinessIcon,
  ViewKanban as ViewKanbanIcon,
  Settings as SettingsIcon,
  EventNote as EventNoteIcon,
} from '@mui/icons-material';

export interface NavigationMenuItem {
  text: string;
  icon: React.ReactNode;
  path: string;
  subItems?: NavigationMenuItem[];
  permissionKey?: string;
}

/** Misma paleta que las cards de ModuloFuncionalidades (índice = orden en el submenú). */
export const COLORES_ICONOS_SUBMENU = [
  '#22a36a',
  '#00a0b9',
  '#8b5cf6',
  '#ef4444',
  '#0ea5e9',
  '#64748b',
  '#14b8a6',
  '#7c3aed',
];

export interface MenuVisual {
  icon: React.ReactNode;
  color: string;
}

export const navigationMenuItems: NavigationMenuItem[] = [
  { text: 'Indicadores', icon: <DashboardIcon />, path: '/dashboard' },
  {
    text: 'Ventas',
    icon: <VentasIcon />,
    path: '/ventas',
    subItems: [
      { text: 'Cotizaciones', icon: <ListAltIcon />, path: '/ventas/cotizaciones' },
      { text: 'Pedidos', icon: <ListAltIcon />, path: '/ventas/pedidos' },
      { text: 'Facturas', icon: <ListAltIcon />, path: '/ventas/facturas' },
      { text: 'Notas de Débito', icon: <ListAltIcon />, path: '/ventas/notas-debito' },
      { text: 'Remitos', icon: <ListAltIcon />, path: '/ventas/remitos' },
      { text: 'Órdenes de Devolución', icon: <AssignmentReturnIcon />, path: '/ventas/ordenes-devolucion' },
      { text: 'Notas de Crédito', icon: <ListAltIcon />, path: '/ventas/notas-credito' },
      { text: 'Plan de visitas', icon: <RouteIcon />, path: '/ventas/visitas' },
      { text: 'Recibos de cobranza', icon: <ReceiptIcon />, path: '/tesoreria/recibos' },
      { text: 'Liquidación de comisiones', icon: <PercentIcon />, path: '/ventas/liquidacion-comisiones' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/ventas/informes' },
      { text: 'Clientes', icon: <CategoryIcon />, path: '/ventas/clientes' },
      { text: 'Vendedores', icon: <ContactsIcon />, path: '/ventas/vendedores' },
      { text: 'Solicitudes ecommerce', icon: <CategoryIcon />, path: '/ventas/clientes/solicitudes-ecommerce' },
      { text: 'Consulta IA Ventas', icon: <ConsultasIcon />, path: '/ventas/consultas-ia' },
    ],
  },
  {
    text: 'Compras',
    icon: <ComprasIcon />,
    path: '/compras',
    subItems: [
      { text: 'Órdenes de Compra', icon: <ListAltIcon />, path: '/compras/ordenes' },
      { text: 'Remitos de Compra', icon: <ListAltIcon />, path: '/compras/remitos' },
      { text: 'Facturas de Compra', icon: <ReceiptIcon />, path: '/compras/facturas' },
      { text: 'Órdenes de pago', icon: <PaymentIcon />, path: '/tesoreria/orden-pago' },
      { text: 'Notas de Crédito', icon: <ListAltIcon />, path: '/compras/notas-credito' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/compras/informes' },
      { text: 'Proveedores', icon: <CategoryIcon />, path: '/compras/proveedores' },
      { text: 'Ramos de Proveedores', icon: <CategoryIcon />, path: '/compras/ramosprov' },
      { text: 'Consulta IA Compras', icon: <ConsultasIcon />, path: '/compras/consultas-ia' },
    ],
  },
  {
    text: 'Inventario',
    icon: <InventarioIcon />,
    path: '/inventario',
    subItems: [
      { text: 'Ajustes y Transf.', icon: <SwapHorizIcon />, path: '/inventario/transferencias' },
      { text: 'Conteo de Stock', icon: <InventarioIcon />, path: '/inventario/conteo' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/inventario/informes' },
      { text: 'Mantenimiento de precios', icon: <PriceChangeIcon />, path: '/inventario/mantenimiento-precios' },
      { text: 'Ofertas', icon: <PercentIcon />, path: '/inventario/descuentos' },
      { text: 'Productos', icon: <CategoryIcon />, path: '/inventario/productos' },
      { text: 'Ramos', icon: <CategoryIcon />, path: '/inventario/ramos' },
      { text: 'Líneas', icon: <CategoryIcon />, path: '/inventario/lineas' },
      { text: 'Clases', icon: <CategoryIcon />, path: '/inventario/clases' },
      { text: 'Unidades de medida', icon: <StraightenIcon />, path: '/inventario/unidades-medida' },
      { text: 'Consulta IA Inventario', icon: <ConsultasIcon />, path: '/inventario/consultas-ia' },
    ],
  },
  {
    text: 'Tesorería',
    icon: <TesoreriaIcon />,
    path: '/tesoreria',
    subItems: [
      { text: 'Planilla de Caja', icon: <ReceiptIcon />, path: '/tesoreria/movimientos-caja' },
      { text: 'Recibos de cobranza', icon: <ListAltIcon />, path: '/tesoreria/recibos' },
      { text: 'Orden de Pago', icon: <ListAltIcon />, path: '/tesoreria/orden-pago' },
      { text: 'Traspasos', icon: <SwapHorizIcon />, path: '/tesoreria/transferencias' },
      { text: 'Movimientos Varios', icon: <ListAltIcon />, path: '/tesoreria/movimientos-varios' },
      { text: 'Movimientos Bancarios', icon: <ListAltIcon />, path: '/tesoreria/movimientos-bancarios' },
      { text: 'Conciliación Bancaria', icon: <ListAltIcon />, path: '/tesoreria/conciliacion-bancaria' },
      { text: 'Informes', icon: <AssessmentIcon />, path: '/tesoreria/informes' },
      { text: 'Consulta IA Tesorería', icon: <ConsultasIcon />, path: '/tesoreria/consultas-ia' },
    ],
  },
  {
    text: 'Contabilidad',
    icon: <MenuBookIcon />,
    path: '/contabilidad',
    subItems: [
      { text: 'Asientos / Libro diario', icon: <ListAltIcon />, path: '/contabilidad/asientos-diario' },
      { text: 'Libro mayor', icon: <AccountTreeIcon />, path: '/contabilidad/libro-mayor' },
      { text: 'Plan de cuentas', icon: <SchemaIcon />, path: '/contabilidad/plan-cuentas' },
      {
        text: 'Informes',
        icon: <AssessmentIcon />,
        path: '/contabilidad/informes',
        subItems: [
          { text: 'Estado de resultados', icon: <AssessmentIcon />, path: '/contabilidad/estado-resultados' },
          { text: 'Situación patrimonial', icon: <AssessmentIcon />, path: '/contabilidad/situacion-patrimonial' },
        ],
      },
      { text: 'Estrategias', icon: <CategoryIcon />, path: '/contabilidad/estrategia' },
    ],
  },
];

export const crmMenuItem: NavigationMenuItem = {
  text: 'CRM',
  icon: <ContactsIcon />,
  path: '/crm',
  subItems: [
    { text: 'Contactos', icon: <ContactsIcon />, path: '/crm/contactos' },
    { text: 'Empresas', icon: <BusinessIcon />, path: '/crm/empresas' },
    { text: 'Pipeline', icon: <ViewKanbanIcon />, path: '/crm/pipeline' },
    { text: 'Agenda', icon: <EventNoteIcon />, path: '/crm/agenda' },
    { text: 'KPIs', icon: <AssessmentIcon />, path: '/crm/kpis' },
    { text: 'Configuración', icon: <SettingsIcon />, path: '/crm/config' },
  ],
};

/** Visible si el catálogo del tenant incluye el módulo Servicio. */
export const servicioMenuItem: NavigationMenuItem = {
  text: 'Servicio',
  icon: <ServicioIcon />,
  path: '/servicio',
  subItems: [
    { text: 'Técnicos', icon: <EngineeringIcon />, path: '/servicio/tecnicos' },
    { text: 'Unidades', icon: <DirectionsCarIcon />, path: '/servicio/vehiculos' },
    { text: 'Turnos', icon: <EventAvailableIcon />, path: '/servicio/turnos' },
    { text: 'Organizador', icon: <CalendarViewWeekIcon />, path: '/servicio/organizador' },
    { text: 'Órdenes de trabajo', icon: <BuildCircleIcon />, path: '/servicio/ordenes-reparacion' },
  ],
};

/** Visible si el catálogo del tenant incluye el módulo Producción. */
export const produccionMenuItem: NavigationMenuItem = {
  text: 'Producción',
  icon: <ProduccionIcon />,
  path: '/produccion',
  subItems: [
    { text: 'Recetas', icon: <RecetaIcon />, path: '/produccion/recetas' },
    { text: 'Órdenes de producción', icon: <OrdenProduccionIcon />, path: '/produccion/ordenes' },
  ],
};

/** Visible si el catálogo del tenant incluye el módulo Fashion. */
export const fashionMenuItem: NavigationMenuItem = {
  text: 'Fashion',
  icon: <FashionIcon />,
  path: '/inventario/fashion',
  subItems: [
    { text: 'Modelos', icon: <ModeloIcon />, path: '/inventario/fashion/modelos' },
    { text: 'Colores', icon: <PaletteIcon />, path: '/inventario/fashion/colores' },
    { text: 'Curvas de talle', icon: <StraightenIcon />, path: '/inventario/fashion/curvas-talle' },
    { text: 'Temporadas', icon: <TemporadaIcon />, path: '/inventario/fashion/temporadas' },
  ],
};

export const allModuleMenus = (): NavigationMenuItem[] => [
  ...navigationMenuItems,
  crmMenuItem,
  servicioMenuItem,
  produccionMenuItem,
  fashionMenuItem,
];

/** Ícono + color de las cards del menú de módulo, indexado por path. */
export const buildMenuVisualByPath = (): Record<string, MenuVisual> => {
  const map: Record<string, MenuVisual> = {};

  const register = (item: NavigationMenuItem, color: string) => {
    map[item.path] = { icon: item.icon, color };
    item.subItems?.forEach((sub, index) => {
      register(sub, COLORES_ICONOS_SUBMENU[index % COLORES_ICONOS_SUBMENU.length]);
    });
  };

  allModuleMenus().forEach((mod) => {
    if (mod.subItems?.length) {
      mod.subItems.forEach((item, index) => {
        register(item, COLORES_ICONOS_SUBMENU[index % COLORES_ICONOS_SUBMENU.length]);
      });
    } else {
      map[mod.path] = {
        icon: mod.icon,
        color: COLORES_ICONOS_SUBMENU[0],
      };
    }
  });

  return map;
};

/** Resuelve visual del menú; para rutas hijas (p.ej. informes/…) hereda del ancestro más cercano. */
export const resolveMenuVisual = (
  path: string,
  visuals: Record<string, MenuVisual>
): MenuVisual | undefined => {
  const bare = path.split('?')[0];
  if (visuals[bare]) return visuals[bare];
  if (visuals[path]) return visuals[path];

  const segments = bare.split('/').filter(Boolean);
  for (let i = segments.length - 1; i >= 1; i -= 1) {
    const candidate = `/${segments.slice(0, i).join('/')}`;
    if (visuals[candidate]) return visuals[candidate];
  }
  return undefined;
};
